import { useState } from 'react';
import type { Course } from '@/types/course';

export default function PreviewPlayer({ course }: { course: Course }) {
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(30);

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-background-200">
        <h2 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
          <span className="w-5 h-5 flex items-center justify-center text-primary-500 text-lg">
            <i className="ri-play-circle-line"></i>
          </span>
          课程视频预览
        </h2>
        <span className="text-[11px] px-2 py-0.5 rounded-md bg-accent-100 text-accent-800 font-medium">
          演示模式
        </span>
      </div>

      <div className="relative w-full aspect-video bg-primary-950 overflow-hidden">
        <img
          src={course.cover}
          alt={`${course.title} 视频预览`}
          title={`${course.title} · 视频预览`}
          className={`w-full h-full object-cover object-top transition-opacity duration-300 ${playing ? 'opacity-40' : 'opacity-80'}`}
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <button
            type="button"
            onClick={() => setPlaying((p) => !p)}
            aria-label={playing ? '暂停' : '播放'}
            className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-background-50/90 text-primary-600 text-3xl md:text-4xl hover:bg-background-50 transition-colors cursor-pointer"
          >
            <i className={playing ? 'ri-pause-fill' : 'ri-play-fill'}></i>
          </button>
        </div>
        {playing && (
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <div className="h-1.5 rounded-full bg-background-50/30 overflow-hidden">
              <div className="h-full bg-accent-500" style={{ width: `${progress}%` }}></div>
            </div>
            <div className="flex items-center justify-between mt-2 text-[11px] text-background-100">
              <span>演示中 · 非真实播放</span>
              <span>12:36</span>
            </div>
          </div>
        )}
      </div>

      <div className="px-4 py-3">
        <div className="flex items-center gap-3">
          <input
            type="range"
            min={0}
            max={100}
            value={progress}
            onChange={(e) => setProgress(Number(e.target.value))}
            className="flex-1 accent-accent-500 cursor-pointer"
            aria-label="播放进度"
          />
          <span className="text-xs text-foreground-500 w-10 text-right">{progress}%</span>
        </div>
        <p className="text-xs text-foreground-500 mt-2 flex items-center gap-1.5">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-information-line"></i>
          </span>
          本视频播放为前端演示，不代表真实播放内容与播放完成状态。
        </p>
      </div>
    </div>
  );
}